import { useMutation } from '@tanstack/react-query'

import { kickAllSessions } from '../../services'

import type { SessionActionResponse } from '@/modules/session/type'
import type {
	UseMutationOptions,
	UseMutationResult,
} from '@tanstack/react-query'

type UseMutationKickAllSessionsOptions = UseMutationOptions<
	SessionActionResponse,
	Error,
	void
>

export default function useMutationKickAllSessions(
	options?: UseMutationKickAllSessionsOptions,
): UseMutationResult<SessionActionResponse, Error, void> {
	return useMutation({
		mutationFn: kickAllSessions,
		...options,
	})
}
